module.exports = __webpack_public_path__ + "static/media/img2.1b3fbf73.jpg";